// ABOUTME: SPEC-82 D-12 — every colour, size, tween and lift of the voice-first dock in ONE place, so
// ABOUTME: "I don't want the glow" is one toggle and "make it blue" is one edit in this file.

import { RAIL_UNIT, CAPTION_BAR_UNIT } from '../../ReelChrome/railGeometry';
import { MOBILE_UNIT } from '../../ReelChrome/mobileGeometry';

// Authored units, in the unit of the composition the piece lives in (see UNIT below). OQ-10: one
// amber and these sizes until design weighs in — nothing else in the experiment names a colour.
const RING_DIAMETER = 176;
export const RING = {
  diameter: RING_DIAMETER,        // authored; the dots' slot is ~140, so the bar's cluster column widens by the overhang
  stroke: 3,
  colour: '#E8A33D',
  glowBlur: 44,
  glowAlpha: 0.9,
  haloMul: 2.2,         // a second, wider and fainter halo behind the tight one: the ring reads as lit, not outlined
  haloAlpha: 0.55,
  coreGlowMul: 0.3,     // a tight, fully opaque layer hugging the stroke: the part of the glow that reads as light, not haze
  pulseMs: 3200,        // slow breathing, not a spinner: it must read as "alive", never as "loading"
  coreScale: 0.74,      // the dots inside the ring: the canvas filled the circle edge to edge, so they sit smaller in it
};

// The pre-tap CTA: a mic in a button sitting inside the ring (concept frame 2, no pill).
// Proportions, not pixels: the slot shrinks to the bar's own height on a short viewport (the ring must never be taller than the
// bar it sits in, or it collides with the row and tooltip measured from the bar's top), so the CTA scales with it.
export const TALK = {
  buttonFrac: 140 / RING_DIAMETER,           // authored 140 button inside the authored 176 ring
  glyphHeightFrac: 73.459 / RING_DIAMETER,    // the existing /reel-chrome/icon-mic.svg artwork (46 x 73.459)
  glyphAspect: 46 / 73.459,
  font: 37.333, minPx: 12,                    // tooltip type, floored so a 320px handset stays readable
  tooltipPadX: 36, tooltipPadY: 20, tooltipRadius: 37,
  tooltipBg: 'rgba(16,16,16,0.82)',           // reel.cta.darkBg: legible over a bright film frame
  arrow: 16,
  sideGap: 28,                                // talk_label_right: mic slot edge to the bubble's arrow tip (mobile authored px)
  buttonBg: 'rgba(16,16,16,0.82)',
  textGlow: '0 0 6px rgba(232,163,61,0.95), 0 0 14px rgba(232,163,61,0.7), 0 0 28px rgba(232,163,61,0.45)',  // the ring's amber
};

export const REVEAL = {
  ms: 220,
  easing: 'cubic-bezier(0.4, 0, 0.2, 1)',     // the chrome's own panel easing (MobileChrome)
  rowGap: 20,                                 // authored gap between the bar's top edge and the row
};

// The revealed row's boxes: the SAME authored boxes as the flanks they replace on each composition.
export const ROW_BOX = {
  desktop: { w: 120, h: 120, gap: 26.667 },
  mobile: { w: 120, h: 117.333, gap: 13 },
};

// How far every bottom-band occupant rises while the row is open: one box + the row gap, in the
// composition's own authored units (the row must clear the bar by REVEAL.rowGap, the band by its own).
export const CONTROLS_LIFT = {
  desktop: ROW_BOX.desktop.h + REVEAL.rowGap,
  mobile: ROW_BOX.mobile.h + REVEAL.rowGap,
};

// OQ-6: legibility without the pill. `none` removes it; the plate gate prints the measured contrast.
export const BARE = { textShadow: '0 0 2px rgba(0,0,0,0.85), 0 1px 3px rgba(0,0,0,0.7), 0 0 10px rgba(0,0,0,0.45)' };

// Which `--u` each piece is authored in: the dots live in the caption bar's unit, the controls in
// the chrome's, exactly where the pieces they replace lived.
export const UNIT = {
  desktop: { core: CAPTION_BAR_UNIT, controls: RAIL_UNIT },
  mobile: { core: MOBILE_UNIT, controls: MOBILE_UNIT },
};

// Where the tooltip and row sit horizontally: centred on the core on desktop, flush with the
// footer's left inset on mobile (a 4-box row centred on the mobile slot would leave the screen).
export const OVERLAY_ALIGN = { desktop: 'center', mobile: 'start' };

export const GLYPH = {
  keyboard: { src: '/reel-chrome/icon-keyboard.svg', w: 72, h: 49.592 },
  mic: { src: '/reel-chrome/icon-mic.svg', w: 46, h: 73.459 },
  micOff: { src: '/reel-chrome/icon-mic-off.svg', w: 72.119, h: 75.346 },
};
